import { Component } from '@angular/core';
import { Header } from '../../components/header/header';

@Component({
  selector: 'app-delete-account',
  imports: [Header],
  templateUrl: './delete-account.html',
  styleUrl: './delete-account.scss',
})
export class DeleteAccount {}
